import * as React from "react";
import * as ReactDOM from "react-dom";

const mountSearch = (): void => {
  document.addEventListener("DOMContentLoaded", async () => {
    const searchRoot = document.querySelector("#algolia-search");

    if (searchRoot instanceof HTMLElement) {
      const { Search } = await import(
        /* webpackPreload: true */
        "../src/search"
      );
      const environment = searchRoot.dataset.environment ?? "development";

      ReactDOM.render(<Search environment={environment} />, searchRoot);
    }

    const searchResultsRoot = document.querySelector("#algolia-search-results");

    if (searchResultsRoot instanceof HTMLElement) {
      const { SearchResultsPage } = await import("../src/search/results_page");
      const environment =
        searchResultsRoot.dataset.environment ?? "development";
      const query = searchResultsRoot.dataset.query ?? "";
      const productsUrl = searchResultsRoot.dataset.productsUrl ?? "";

      ReactDOM.render(
        <SearchResultsPage
          environment={environment}
          query={query}
          productsUrl={productsUrl}
        />,
        searchResultsRoot
      );
    }
  });
};

mountSearch();
